import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../utils/firebase/firebase.utils";
import { setTeamIndex, setUser } from "../store/user/user.action";
import { selectUser } from "../store/user/user.selector";
import { serializeFirestoreData } from "../utils/firebase/serialization";

export function useUserTeamIndexListener() {
  const user = useSelector(selectUser);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!user) return;

    const userDocRef = doc(db, `users/${user.uid}`);
    const unsubscribe = onSnapshot(userDocRef, (docSnap) => {
      if (docSnap.exists()) {
        const userData = serializeFirestoreData(docSnap.data());
        const { teamIndex, tokens } = userData;
        if (teamIndex !== undefined && teamIndex !== null) {
          dispatch(setTeamIndex(teamIndex));
        }
        if (tokens !== undefined && tokens !== null && user.tokens !== tokens) {
          dispatch(setUser({ ...user, tokens }));
        }
      }
    });

    return () => unsubscribe();
  }, [user, dispatch]);
}
